<template>
	<q-layout-footer>
		<q-toolbar
			class="q-py-lg footer-desktop mobile-hide"
			:style="$q.platform.is.edge ? 'height: 180px' : ''"
		>
			<div class="row fit justify-center">
				<div class="col-sm-10">
					<div class="row gutter-md">
						<div class="col-3">
							<div class="row  gutter-xs flex justify-center">
								<div class=" col-12 logo text-center">
									<img :src="getLogo" class="logo-footer-desktop" />
								</div>

								<!-- Portugues -->
								<div
									class="col-6"
									v-if="urlStoreGoogle && id_user_language_selected == 1"
								>
									<a :href="urlStoreGoogle">
										<img
											src="~assets/store_icons/google_portugues.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<!-- English -->
								<div
									class="col-6"
									v-if="urlStoreGoogle && id_user_language_selected == 2"
								>
									<a :href="urlStoreGoogle">
										<img
											src="~assets/store_icons/google_ingles.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<!-- Español -->
								<div
									class="col-6"
									v-if="urlStoreGoogle && id_user_language_selected == 3"
								>
									<a :href="urlStoreGoogle">
										<img
											src="~assets/store_icons/google_espanhol.png"
											style="width: 100%"
										/>
									</a>
								</div>

								<!-- Fraçais -->
								<div
									class="col-6"
									v-if="urlStoreGoogle && id_user_language_selected == 4"
								>
									<a :href="urlStoreGoogle">
										<img
											src="~assets/store_icons/google_frances.png"
											style="width: 100%"
										/>
									</a>
								</div>
							</div>
						</div>

						<div class="col-3">
							<h5 class="no-margin q-pb-md">{{ $t('institutional') }}</h5>

							<p v-for="(inst, index) in institutional" :key="index">
								<router-link :to="{ name: inst.to }">{{
									$t(inst.name)
								}}</router-link>
							</p>
						</div>

						<div class="col-3">
							<h5 class="no-margin q-pb-md">{{ $t('questions') }}</h5>

							<p v-for="(question, index) in questions" :key="index">
								<router-link :to="{ name: question.to }">{{
									$t(question.name)
								}}</router-link>
							</p>
						</div>

						<div class="col-3">
							<h5 class="no-margin q-pb-md">{{ $t('access') }}</h5>

							<p v-for="(link, index) in links" :key="index" v-if="showLink(link.to)">
								<router-link :to="{ name: link.to }">{{
									$t(link.name)
								}}</router-link>
							</p>
						</div>
					</div>
				</div>
			</div>
		</q-toolbar>

		<q-toolbar class="mobile-hide bg-primary" style="padding: 0px; min-height: 30px;">
			<q-toolbar-title class="text-center text-weight-light">
				<small
					>Copyright © {{ new Date().getFullYear() }}: {{ getProjectName }} v{{
						getVersion
					}}
					- Powered by <a href="https://take5.com.br">Take 5 LMS</a></small
				>
			</q-toolbar-title>
		</q-toolbar>

		<q-toolbar class="desktop-hide">
			<q-toolbar-title class="text-center">
				<div class="logo">
					<img :src="getLogo" class="logo-footer" />
				</div>
			</q-toolbar-title>
			<q-btn flat round dense @click="openMenu()" icon="far fa-bars" />
		</q-toolbar>

		<q-modal
			v-model="show_modal"
			:content-css="{ minWidth: '80vw', maxWidth: '100vw', minHeight: '90vh' }"
			@hide="show_modal = false"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_modal = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('download_app') }}
					</q-toolbar-title>
				</q-toolbar>
			</q-modal-layout>
		</q-modal>
	</q-layout-footer>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'authenticated'] },

	data() {
		return {
			questions: [{ name: 'frequent_questions', to: 'faq' }, { name: 'help', to: 'help' }],
			institutional: [
				{ name: 'about_the_company', to: 'institutional-about' },
				{ name: 'privacy_policy', to: 'institutional-privacy' },
				{ name: 'terms_conditions', to: 'institutional-terms' },
			],
			loading: false,
			show_modal: false,
			codes: [],
			columns: [
				{
					name: 'redemption_link',
					required: true,
					label: 'download',
					align: 'left',
					field: 'redemption_link',
					sortable: false,
				},
				{
					name: 'code',
					required: true,
					label: 'redemption_code',
					align: 'left',
					field: 'code',
					sortable: false,
				},
				{
					name: 'created_date',
					required: true,
					label: 'creation_date',
					align: 'left',
					field: 'created_date',
					sortable: false,
				},
			],
			disable_new_code: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_campaign_selected: 'common/id_user_campaign_selected',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			logo: 'params/login_logo',
			register_fields: 'params/register_fields',
			user_clients: 'common/user_clients',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getLogo() {
			let obj = this.clients.find((obj) => {
				return obj.id == this.id_user_client_selected
			})

			if (obj && obj.logo_footer && obj.logo_footer !== 'https://image.jpg')
				return obj.logo_footer
			else return this.logo
		},

		links() {
			let links = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					links.push({
						name: obj.title_trainings == '' ? 'courses' : obj.title_trainings,
						to: 'courses',
					})

					links.push({
						name: obj.title_trails == '' ? 'trails' : obj.title_trails,
						to: 'trails',
					})

					links.push({
						name: obj.title_library == '' ? 'library' : obj.title_library,
						to: 'library',
					})

					links.push({
						name: obj.title_webcasts == '' ? 'webcasts' : obj.title_webcasts,
						to: 'webcasts',
					})
				}
			}
			return links
		},

		urlStoreGoogle() {
			if (process.env.APP_URL_GOOGLE) {
				if (this.$q.platform.is.cordova) return process.env.APP_URL_GOOGLE
				else
					return `https://play.google.com/store/apps/details?id=${process.env.CORDOVA_ID}`
			}
			return ''
		},

		getProjectName() {
			return process.env.PROJECT_NAME
		},

		getVersion() {
			return process.env.APP_VERSION
		},
	},

	methods: {
		openMenu() {
			this.$store.dispatch('common/SET_RIGHT_MENU', [true])
		},

		clearDatatables() {
			this.$q.localStorage.remove('dataTableTags')
			this.$q.localStorage.remove('dataTableTrainings')
			this.$q.localStorage.remove('dataTableTrals')
			this.$q.localStorage.remove('dataTablelibraryCategories')
			this.$q.localStorage.remove('dataTableLibraries')
			this.$q.localStorage.remove('dataTableWebcast')
			this.$q.localStorage.remove('15-user-columns')
			this.$q.localStorage.remove('dataTableUsersGroups')
			this.$q.localStorage.remove('dataTableBranches')
			this.$q.localStorage.remove('dataTableQuestions')
			this.$q.localStorage.remove('dataTableTask')
			this.$q.localStorage.remove('dataTableSurveys')
			this.$q.localStorage.remove('dataTableMessages')
			this.$q.localStorage.remove('dataTableNews')
			this.$q.localStorage.remove('dataTableFaq')
			this.$q.localStorage.remove('dataTableFaqCategories')
			this.$q.localStorage.remove('dataTableBanners')
			this.$q.localStorage.remove('dataTableBannerWelcome')
			this.$q.localStorage.remove('dataTableHeadQuarters')
		},

		showLink(link) {
			if (this.id_user_client_selected) {
				let client = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (client) {
					switch (link) {
						case 'courses':
							return client.has_courses
							break
						case 'trails':
							return client.has_trails
							break
						case 'library':
							return client.has_library
							break
						case 'webcasts':
							return client.has_webcasts
							break
						default:
							return false
							break
					}
				}
			} else return false
		},

		open_modal() {
			this.show_modal = true
			this.disable_new_code = false
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},

		openLink(link) {
			if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
				cordova.InAppBrowser.open(
					link,
					'_system',
					'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no'
				)
			} else {
				window.open(link, '_blank')
			}
		},

		filterLinks() {
			let hasFaq = false
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					hasFaq = obj.has_faq
				}
			}

			hasFaq
				? (this.questions = this.questions)
				: (this.questions = this.questions.filter((l) => l.to !== 'faq'))
		},
	},

	mounted() {
		this.filterLinks()
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables'
p
    margin 0 0 10px

.logo-footer-desktop
    width auto
    height 35px
    -webkit-filter brightness(0) invert(1)
    filter brightness(0) invert(1)
    max-width 100%

.logo-footer
    width auto
    max-height 35px
    -webkit-filter brightness(0) invert(1)
    filter brightness(0) invert(1)
    max-width 100%

.redemption-link
    color #000000

a
    color #ffffff
    text-decoration none
</style>
